import { render } from "./DouyinWorkerCmt.vue?vue&type=template&id=1e1c984b&scoped=true"
import script from "./DouyinWorkerCmt.vue?vue&type=script&lang=js"
export * from "./DouyinWorkerCmt.vue?vue&type=script&lang=js"

import "./DouyinWorkerCmt.vue?vue&type=style&index=0&id=1e1c984b&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1c984b"]])

export default __exports__